/**
 * Helpers for deal purpose (acquisition vs owned property).
 */

export const DEAL_PURPOSE_ACQUISITION = 'acquisition';
export const DEAL_PURPOSE_OWNED = 'owned';

export const FINANCING_TYPE_EXISTING = 'existing';
export const FINANCING_TYPE_NONE = 'none';

/**
 * @param {{ dealPurpose?: string } | null | undefined} property
 * @returns {boolean}
 */
export function isOwnedDeal(property) {
  return property?.dealPurpose === DEAL_PURPOSE_OWNED;
}

/**
 * @param {string | null | undefined} financingType
 * @returns {boolean}
 */
export function isInPlaceLoanFinancing(financingType) {
  return financingType === 'assumption' || financingType === FINANCING_TYPE_EXISTING;
}

/**
 * @param {string | null | undefined} financingType
 * @returns {boolean}
 */
export function isZeroDebtFinancing(financingType) {
  return financingType === FINANCING_TYPE_NONE;
}
